import React, { useState } from 'react';
import { useWorkflows } from '../../hooks';
import { ResourceGridPage } from '../ui';
import CreateWorkflowModal from './CreateWorkflowModal';
import WorkflowCard from './WorkflowCard';

const WorkflowSection = () => {
  const [createOpen, setCreateOpen] = useState(false);
  const getAllWorkflows = useWorkflows();
  const workflows = getAllWorkflows?.data?.workflows || [];

  return (
    <>
      {createOpen && <CreateWorkflowModal onClose={() => setCreateOpen(false)} />}

      <ResourceGridPage
        title="Workflows"
        subtitle="Create a new workflow or select an existing one to get started."
        createLabel="Create Workflow"
        onCreate={() => setCreateOpen(true)}
        searchPlaceholder="Search workflow by name"
        items={workflows}
        loading={getAllWorkflows.isPending}
        showDiscover={false}
        mineTabLabel="My Workflows"
        getItemKey={item => item.workflow_id || item.id}
        getItemName={item => item.name || ''}
        getItemDescription={item => item.description || ''}
        mineContent={filtered => (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            <WorkflowCard workflowCardsData={filtered} />
          </div>
        )}
      />
    </>
  );
};

export default WorkflowSection;
